import { isAppModule } from '@src/utils/constants';
import React from 'react';
import lodash from 'lodash';
import { Button } from 'antd';
import { trendsExportConfig, appEventsExportConfig } from '@components/export/utils';
import { optionMapping } from '../constants';
import { useOptionsExport } from '../useOptionsExport';

export const ExportAllButton = (props: {
  disabled: boolean;
  sections: string[];
  selectedMetrics: string[];
  selectedDimensions: string[];
  onDone: () => void;
}) => {
  const { disabled, sections, selectedMetrics, selectedDimensions, onDone } = props;
  const initConfig = isAppModule
    ? lodash.cloneDeep(appEventsExportConfig)
    : lodash.cloneDeep(trendsExportConfig);
  const configSections = [...initConfig.sections];
  const selectedSections = Array.from(new Set(sections.map((i) => optionMapping[i])));
  const resSections: { key: string; title: string; order?: string[]; selected?: string[] }[] = [];
  configSections.forEach((i) => {
    if (i.key === 'metrics-panel' && selectedSections.includes(i.key)) {
      resSections.push({ ...i, selected: selectedMetrics });
      return;
    } else if (i.key === 'dimensions-panel' && selectedSections.includes(i.key)) {
      resSections.push({ ...i, selected: selectedDimensions });
      return;
    } else if (selectedSections.includes(i.key)) {
      resSections.push(i);
    }
  });
  initConfig.sections = resSections;
  const { triggerDownload } = useOptionsExport({ config: initConfig });

  const onClick = () => {
    triggerDownload();
    setTimeout(() => {
      onDone();
    }, 250);
  };

  return (
    <Button onClick={onClick} type="primary" ghost disabled={disabled}>
      Export
    </Button>
  );
};
